import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-approver-chat-modal',
  templateUrl: './approver-chat-modal.component.html',
  styleUrls: ['./approver-chat-modal.component.scss']
})
export class ApproverChatModalComponent {

  @Input() isOpen: boolean = false;
  @Input() chatData: any;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
